import request from '@/api/request'

export const analyseProject = (params) => {
    return request({
        url: 'admin/analyse/adm/analyseProject/page',
        params,
        method: 'get'
    })
}

export const addAnalyseProject = (data) => {
    return request({
        url: 'admin/analyse/adm/analyseProject/add',
        data,
        method: 'post'
    })
}

export const updateAnalyseProject = (data) => {
    return request({
        url: 'admin/analyse/adm/analyseProject/update',
        data,
        method: 'post'
    })
}

export const checkAnalyseProject = (params) => {
    return request({
        url: 'admin/analyse/adm/analyseProject/checkAnalyseProject',
        params,
        method: 'get'
    })
}